import styled, { css } from 'styled-components';
import {
  NavBarHeight,
  NavBarHeightMobile,
  SubNavBarHeight,
  SubNavBarHeightMobile,
} from '../../../../const';

const navbarPadding = '0 35px 0 16px';

export const NavBarContainer = styled.header`
  position: sticky;
  top: 0;
  width: 100%;
  max-width: var(--full-width);
  height: fit-content;
  color: ${(props) => props.theme.colors.white};
  z-index: ${(props) => props.theme.zIndex.navBar};
  background-color: ${(props) => props.theme.colors.bgHeader};
`;

export const FirstNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  height: ${NavBarHeightMobile}px;
  width: 100%;
  padding: ${navbarPadding};
`;

export const SecondNav = styled.div`
  width: var(--full-width);
  height: ${SubNavBarHeightMobile}px;
  background-color: ${(props) => props.theme.colors.bgSubHeader};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${navbarPadding};
  position: relative;
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: auto;
`;
export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 0;
  position: relative;

  @media ${(props) => props.theme.device.tabletL} {
    flex-direction: column;
    height: calc(${NavBarHeight}px + ${SubNavBarHeightMobile}px);
  }
`;

export const Text = styled.div`
  font-size: 12px;
  font-weight: 600;
`;

export const MenuElement = styled.span`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  transition: ${(props) => props.theme.constants.transitionBase};

  &:hover {
    color: ${(props) => props.theme.mixin.rgba(props.theme.colors.white, 0.6)};
  }

  span {
    margin-right: 10px;
  }
`;

export const SidebarMenu = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isOpen'].includes(prop),
})`
  background-color: ${(props) => props.theme.colors.themeColor};
  top: calc(100% + 10px);
  right: 281px;
  position: absolute;
  padding: 10px;
  width: 150px;
  display: none;
  transition: ${(props) => props.theme.constants.transitionBase};
  ${(props) =>
    props.isOpen &&
    css`
      right: 281px;
      display: block;
    `};

  ${MenuElement} {
    width: 100%;
    &:not(:last-child) {
      padding-bottom: 10px;
      margin-bottom: 10px;
    }
  }
`;

const Modal = styled.div`
  position: absolute;
  top: calc(-${SubNavBarHeight}px);
  right: 32px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.bgPrimary};
  color: ${(props) => props.theme.colors.textPrimary};
  box-shadow: 1px 1px 12px 0px rgba(50, 50, 50, 0.55);
  transition: ${(props) => props.theme.constants.transitionBase};

  @media screen and (max-width: 1023px) {
    left: 32px;
    right: unset;
  }

  @media ${(props) => props.theme.device.tabletL} {
    border-radius: 0px;
    &.menu-mobile {
      background-color: ${(props) => props.theme.colors.bgPrimary};
      max-height: 100%;

      &.open {
        position: fixed;
        display: initial;
        top: calc(${NavBarHeight}px + ${SubNavBarHeightMobile}px);
        left: 0;
        border: none;
        margin-bottom: 0;
        height: calc(100vh - ${NavBarHeight}px);
        min-height: 100%;
        min-width: 100%;
        padding: 5px;
      }
    }
  }
`;

export const UserMenuModal = styled(Modal)`
  width: fit-content;
  margin-left: auto;
  margin-right: -22px;
  min-width: 280px;
  margin-right: 150px;

  & .with-border {
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid ${(props) => props.theme.colors.textSecondary};
  }

  @media screen and (max-width: 1279px) {
    position: fixed;
    margin: unset;
    top: ${NavBarHeight}px;
  }
  @media screen and (max-width: 1023px) {
    left: 365px;
  }
`;

export const ModalIconWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 20px 30px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.bgSecondary};
  }

  & span {
    margin-right: 20px;
  }
`;

export const Status = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: ${(props) => props.theme.colors.link};
`;

export const NameContainer = styled.div`
  height: ${NavBarHeight}px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 0 12px;
  background-color: ${(props) => props.theme.colors.bgSubHeader};
  cursor: pointer;
`;

export const FullName = styled.div``;

export const MobileIconContainer = styled.div`
  display: flex;
  align-items: center;
  width: 75%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const FaqContainer = styled.div`
  margin-left: 20px;
`;
export const IconsContainer = styled.div`
  display: flex;
  margin-right: 10px;
`;
export const IconContainer = styled.div``;
export const NotificationBadge = styled.span``;
export const IconSpan = styled.span`
  font-size: 20px;

  &.disactive {
    position: relative;
    &::after {
      content: '';
      width: 141%;
      height: 2px;
      border-radius: 2px;
      position: absolute;
      bottom: 8px;
      left: -4px;
      -ms-transform: rotate(45deg);
      transform: rotate(-45deg);
      background-color: ${(props) => props.theme.colors.textPrimary};
    }
  }
`;

export const LogoutWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  cursor: pointer;

  svg {
    stroke: ${(props) => props.theme.colors.bgHeader};
  }
`;

export const IconWrapperLogout = styled.div`
  padding: 4px;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 100%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SearchContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['nameOffset'].includes(prop),
})`
  position: absolute;
  right: -8px;
  top: -8px;

  > form {
    opacity: 0;
    width: 0;
  }

  form {
    @keyframes search-slidein {
      0% {
        width: 0;
        opacity: 0;
      }
      100% {
        width: 300px;
        opacity: 1;
      }
    }
  }

  form {
    @keyframes search-slideout {
      0% {
        width: 300px;
        opacity: 1;
      }
      100% {
        width: 0;
        opacity: 0;
      }
    }
  }

  &.slidein > form {
    animation: 0.25s linear search-slidein forwards;
  }

  &.slideout > form {
    animation: 0.25s linear search-slideout forwards;
  }

  @media (max-width: 600px) {
    form {
      @keyframes search-slidein {
        0% {
          width: 0;
          opacity: 0;
        }
        100% {
          width: calc(${({ nameOffset }) => nameOffset}px - 24px);
          opacity: 1;
        }
      }
    }

    form {
      @keyframes search-slideout {
        0% {
          opacity: 1;
          width: calc(${({ nameOffset }) => nameOffset}px - 24px);
        }
        100% {
          width: 0;
          opacity: 0;
        }
      }
    }

    &.slidein > form {
      animation: 0.25s linear search-slidein forwards;
    }

    &.slideout > form {
      animation: 0.25s linear search-slideout forwards;
    }
  }
`;
